import React, { useEffect, useRef, useState } from 'react'
import { Breadcrumbs, Tabs, CreateButton, DropDownMenu, DynamicEntityIndex, FlashMessage, GlobalLoader, InputField, Modal, ModalAlert, SaveFixedButton, SelectInput } from '@reactiveonline/reactive_admin_shared-packages'
import { dynamicTableItemRenderer, emailValidation } from '@reactiveonline/reactive_admin_shared-packages/utils'
import Toggle from 'react-toggle'
import GlobalImports from '../shared/GlobalImports'
import AffiliateLinksDrawer from '../affiliate_codes/AffiliateLinksDrawer'
import Drawer from '../shared/Drawer'

const initialNewBranchState = {
  name: '',
  branchAdministratorEmail: '',
  uid: '',
  internalName: '',
  branchLocation: '',
  region: -1
}

export default function Edit({
  appProps, administratorsCount, administratorIcon, administratorListColumns, administratorSelectedColumns, affiliateCodeIcon, affiliateCodeListColumns, affiliateCodeSelectedColumns, affiliateCodesPath, branchesCount, branchesPath, branchIcon, branchListColumns, branchSelectedColumns, breadcrumbs,
  canCreateAffiliateCodes, canCreateBranches, canDeleteAdministrators, canDeleteBranches, canEditBranch, canEditOrganization, canInviteOrganizationAdministrator, canEditAdministrator, canManageAffiliateCodes, canManageFees, canViewAdministrator, createAffiliateCodePath,
  deleteAdministratorsPath, deleteBranchesPath, deleteRegionsPath, exportAdminsPath, exportBranchesPath, exportRegionsPath, getAdministratorsPath, feesPath, hideFees, inviteNewOrganizationAdminPath, organization, organizationIcon, organizationsPath, regionIcon, regionListColumns,
  regionsPath, regionSelectedColumns, deleteAffiliateCodePath, updateAdministratorPath, updateAffiliateCodePath, updatePath, reinvitePath
}) {
  const [saveButtonRef, setSaveButtonRef] = useState(null)
  const [organizationName, setOrganizationName] = useState(organization.name)
  const [organizationState, setOrganizationState] = useState(organization)
  const [branches, setBranches] = useState([])
  const [regions, setRegions] = useState(organization.regions)
  const [affiliateCodes, setAffiliateCodes] = useState([])
  const [administrators, setAdministrators] = useState([])
  const [branchesCountState, setBranchesCountState] = useState(branchesCount)
  const [administratorsCountState, setAdministratorsCountState] = useState(administratorsCount)
  const [showCreateBranchModal, setShowCreateBranchModal] = useState(false)
  const [showAddNewAdminModal, setShowAddNewAdminModal] = useState(false)
  const [showCreateRegionModal, setShowCreateRegionModal] = useState(false)
  const [showCreateAffiliateCodeModal, setShowCreateAffiliateCodeModal] = useState(false)
  const [affiliateCodeToBeEdited, setAffiliateCodeToBeEdited] = useState(null)
  const [newBranch, setNewBranch] = useState(initialNewBranchState)
  const [newAffiliateCode, setNewAffiliateCode] = useState({
    administratorId: organization.affiliateCodeAdministrators[0]?.value,
    code: '',
    expiresAt: '',
    active: true
  })
  const [newAdministratorEmail, setNewAdministratorEmail] = useState('')
  const [newAdministratorName, setNewAdministratorName] = useState('')
  const [newAdministratorUid, setNewAdministratorUid] = useState('')
  const [newRegionName, setNewRegionName] = useState('')
  const [newRegionUid, setNewRegionUid] = useState('')
  const [updatedName, setUpdatedName] = useState('')
  const [updatedUid, setUpdatedUid] = useState('')
  const [administratorToBeDeleted, setAdministratorToBeDeleted] = useState(null)
  const [administratorToBeEdited, setAdministratorToBeEdited] = useState(null)
  const [loading, setLoading] = useState(false)
  const [renderKey, setRenderKey] = useState(0)
  const [affiliateCodeRenderKey, setAffiliateCodeRenderKey] = useState(0)
  const [adminRenderKey, setAdminRenderKey] = useState(0)
  const [regionRenderKey, setRegionRenderKey] = useState(0)
  const [currentTab, setCurrentTab] = useState('regions')
  const [affiliateCodeToBeDeleted, setAffiliateCodeToBeDeleted] = useState(null)
  const [affiliateCodeLinksModalItem, setAffiliateCodeLinksModalItem] = useState(null)

  const didMountRef = useRef(false)
  const flashMessageRef = useRef(null)

  useEffect(() => {
    if (didMountRef.current) {
      saveButtonRef.setSaveableStatus()
    } else {
      didMountRef.current = true
    }
  }, [organizationState])

  const actions = []

  if (canEditBranch) {
    actions.unshift({ url: item => `${ branchesPath }/${ item.apiUid }/edit`, icon: 'fa-pencil' })
  }

  const administratorActions = []

  if (canDeleteAdministrators) {
    administratorActions.unshift({ onClick: (event, item) => handleDeleteAdministratorClick(item.apiUid, event), icon: 'fa-trash' })
  }

  if (canEditAdministrator) {
    administratorActions.unshift({ onClick: (event, item) => handleEditAdministratorClick(item.apiUid, event), icon: 'fa-pencil' })
  }

  if (canInviteOrganizationAdministrator) {
    administratorActions.unshift({ onClick: (event, item) => handleReinvite(item, event), icon: 'fa-envelope'})
  }

  const affiliateCodeActions = []

  affiliateCodeActions.unshift({ onClick: (event, item) => handleAffiliateLinksClick(item, event), icon: 'fa-link' })

  if (canManageAffiliateCodes) {
    affiliateCodeActions.unshift({ onClick: (event, item) => handleEditAffiliateCodeClick(item, event), icon: 'fa-pencil' })
    affiliateCodeActions.unshift({
      onClick: (event, item) => handleDeleteAffiliateCodeClick(item.apiUid, event),
      icon: 'fa-trash',
      hide: item => item.usageCount > 0
    })
  }

  const handleOrganizationSave = () => {
    const fd = new FormData()
    fd.append('id', organizationState.id)
    fd.append('organization[name]', organizationState.name)
    fd.append('organization[uid]', organizationState.uid)
    fd.append('organization[internal_name]', organizationState.internalName)

    saveButtonRef.setSavingStatus()

    Rails.ajax({
      type: 'PATCH',
      url: updatePath,
      dataType: 'json',
      data: fd,
      success: res => {
        saveButtonRef.setSuccessStatus()

        setOrganizationState(res.organization)
        setOrganizationName(res.organization.name)
      },
      error: res => saveButtonRef.setErrorStatusWithMessage(res.errors)
    })
  }

  const closeCreateBranchModal = () => {
    setNewBranch(initialNewBranchState)
    setShowCreateBranchModal(false)
  }

  const closeCreateRegionModal = () => {
    setNewRegionName('')
    setNewRegionUid('')
    setShowCreateRegionModal(false)
  }

  const closeCreateAffiliateCodeModal = () => {
    setAffiliateCodeToBeEdited(null)
    setNewAffiliateCode({
      administratorId: organization.affiliateCodeAdministrators[0]?.value,
      code: '',
      expiresAt: '',
      active: true
    })
    setShowCreateAffiliateCodeModal(false)
  }

  const createBranch = () => {
    const { name, branchAdministratorEmail, uid, internalName, branchLocation, region } = newBranch

    const fd = new FormData()
    fd.append('branch[organization_id]', organizationState.id)
    fd.append('branch[name]', name)
    fd.append('branch[uid]', uid)
    fd.append('branch[internal_name]', internalName)
    fd.append('branch[branch_location]', branchLocation)
    if (region > 0) {
      fd.append('branch[region_id]', region)
    }
    fd.append('admin_email', branchAdministratorEmail)

    setLoading(true)
    closeCreateBranchModal()

    Rails.ajax({
      type: 'POST',
      url: branchesPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setBranchesCountState(res.branchesCount)
        setRenderKey(Math.random())
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.message, 'error')
        setLoading(false)
      }
    })
  }

  const openEditAffiliateCodeModal = affiliateCode => {
    setAffiliateCodeToBeEdited(affiliateCode.apiUid)
    setNewAffiliateCode({
      administratorId: affiliateCode.administratorId,
      code: affiliateCode.code,
      expiresAt: affiliateCode.expiresAtValue || '',
      active: affiliateCode.active
    })
    setShowCreateAffiliateCodeModal(true)
  }

  const createRegion = () => {
    const fd = new FormData()
    fd.append('region[name]', newRegionName)
    fd.append('region[uid]', newRegionUid)
    fd.append('region[organization_id]', organizationState.id)

    setLoading(true)

    closeCreateRegionModal()

    Rails.ajax({
      type: 'POST',
      url: regionsPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message)
        setRegions(res.regions)
        setLoading(false)
        setRegionRenderKey(Math.random())
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  const createAffiliateCode = () => {
    const fd = new FormData()

    fd.append('affiliate_code[administrator_id]', newAffiliateCode.administratorId)
    if (newAffiliateCode.code) {
      fd.append('affiliate_code[code]', newAffiliateCode.code)
    }
    if (newAffiliateCode.expiresAt) {
      fd.append('affiliate_code[expires_at]', newAffiliateCode.expiresAt)
    }
    fd.append('affiliate_code[active]', newAffiliateCode.active)

    closeCreateAffiliateCodeModal()
    setLoading(true)

    const isEditMode = !!affiliateCodeToBeEdited
    const actionUrl = isEditMode ? updateAffiliateCodePath.replace(':affiliate_code_api_uid', affiliateCodeToBeEdited) : createAffiliateCodePath

    Rails.ajax({
      type: isEditMode ? 'PATCH' : 'POST',
      url: actionUrl,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setAffiliateCodeRenderKey(Math.random())
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.message, 'error')
        setLoading(false)
      }
    })
  }

  const generateAffiliateCode = () => {
    const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
    let code = ''

    for (let index = 0; index < 10; index++) {
      code += characters[Math.floor(Math.random() * characters.length)]
    }

    setNewAffiliateCode(prevState => ({ ...prevState, code: code }))
  }

  const verifyFields = () => {
    const { name, branchAdministratorEmail, uid, internalName } = newBranch

    if ([name, uid, internalName].includes('') || !emailValidation(branchAdministratorEmail)) {
      return true
    }

    return false
  }

  const closeAddNewAdminModal = () => {
    setNewAdministratorEmail('')
    setNewAdministratorName('')
    setNewAdministratorUid('')
    setShowAddNewAdminModal(false)
  }

  const inviteOrganizationAdministrator = () => {
    const fd = new FormData()
    fd.append('id', organizationState.id)
    fd.append('admin_email', newAdministratorEmail)
    fd.append('admin_name', newAdministratorName)
    fd.append('admin_uid', newAdministratorUid)

    closeAddNewAdminModal()
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: inviteNewOrganizationAdminPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setAdministratorsCountState(res.administratorsCount)
        setAdminRenderKey(Math.random())
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.message, 'error')
        setLoading(false)
      }
    })
  }

  const itemRenderer = (item, columns) =>  {
    return (
      <>
        { columns.map(column => {
          if (column.label === 'name') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ `${ branchesPath }/${ item.apiUid }/edit` }>
                  { item[column.label] }
                </a>
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  const administratorItemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => {
          if (column.label === 'email') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ `${ organizationsPath }/${ organization.apiUid }/administrators/${ item.apiUid }`}>
                  { item[column.label] }
                </a>
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  const regionItemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => {
          if (column.label === 'name') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ `${ regionsPath }/${ item.apiUid }/edit` }>
                  { item[column.label] }
                </a>
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  const affiliateCodeItemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => {
          if (column.label === 'active') {
            return (
              <div key={ column.label } className='item flex-1'>
                <i className={ `fa-light ${ item.active ? 'fa-circle-check' : 'fa-circle-xmark' }` }/>
              </div>
            )
          }

          return dynamicTableItemRenderer(item, column)
        })}
      </>
    )
  }

  const handleDeleteAdministratorClick = (adminApiUid, event) => {
    event.preventDefault()
    setAdministratorToBeDeleted(adminApiUid)
  }

  const handleDeleteAffiliateCodeClick = (affiliateCodeApiUid, event) => {
    event.preventDefault()
    setAffiliateCodeToBeDeleted(affiliateCodeApiUid)
  }

  const handleEditAffiliateCodeClick = (affiliateCode, event) => {
    event.preventDefault()
    openEditAffiliateCodeModal(affiliateCode)
  }

  const handleAffiliateLinksClick = (affiliateCode, event) => {
    event.preventDefault()
    setAffiliateCodeLinksModalItem(affiliateCode)
  }

  const handleDeleteAffiliateCode = () => {
    const deletePath = deleteAffiliateCodePath.replace(':affiliate_code_api_uid', affiliateCodeToBeDeleted)

    setAffiliateCodeToBeDeleted(null)
    setLoading(true)

    Rails.ajax({
      type: 'DELETE',
      url: deletePath,
      dataType: 'json',
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setAffiliateCodeRenderKey(Math.random())
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.message, 'error')
        setLoading(false)
      }
    })
  }

  const handleEditAdministratorClick = (adminApiUid, event) => {
    event.preventDefault()

    const relevantAdmin = administrators.find(el => el.apiUid === adminApiUid)

    setAdministratorToBeEdited(adminApiUid)
    setUpdatedName(relevantAdmin.name ?? '')
    setUpdatedUid(relevantAdmin.uid ?? '')
  }

  const handleDeleteAdministrator = _e => {
    const fd = new FormData()

    fd.append('administrator_api_uid', administratorToBeDeleted)

    setAdministratorToBeDeleted(null)
    setLoading(true)

    Rails.ajax({
      type: 'DELETE',
      url: deleteAdministratorsPath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        setAdminRenderKey(Math.random())
        setAdministratorsCountState(res.administratorsCount)
        flashMessageRef.current.show(res.message)
      }
    })
  }

  const handleUpdateAdministrator = _e => {
    const fd = new FormData()

    fd.append('administrator_api_uid', administratorToBeEdited)
    fd.append('administrator[name]', updatedName)
    fd.append('administrator[uid]', updatedUid)

    setLoading(true)

    Rails.ajax({
      type: 'PATCH',
      url: updateAdministratorPath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        setAdminRenderKey(Math.random())
        setAdministratorToBeEdited(null)
        flashMessageRef.current.show(res.message)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.errors, 'error')
      }
    })
  }

  const tabs = [
    { key: 'regions', title: Partners.translations.region.plural },
    { key: 'branches', title: Partners.translations.branch.plural }
  ]

  if (!!canViewAdministrator) {
    tabs.push( { key: 'administrators', title: Partners.translations.administrator.plural } )
  }
  if (canManageAffiliateCodes) {
    tabs.push( { key: 'affiliateCodes', title: Partners.translations.affiliateCode.plural } )
  }

  const handleReinvite = (administrator, e) => {
    e.preventDefault()

    if (!administrator.canReinvite) {
      flashMessageRef.current.show(Partners.translations.administrator.has_accepted_invite, 'error')

      return
    }

    const fd = new FormData()

    fd.append('administrator_api_uid', administrator.apiUid)

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: reinvitePath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light ${ organizationIcon }` }/>
              <h1 className='page-header-title'>
                { organizationName }
              </h1>
            </div>

            { canManageFees && !hideFees &&
              <a href={ feesPath } className='btn'>
                { Partners.translations.fee.manage_fees }
              </a>
            }
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <div className='card m-b-50'>
        <div className='card-content'>
          <div className='card-body'>
            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.attributes.name }
              >
                <input
                  type='text'
                  value={ organizationState.name }
                  onChange={ e => setOrganizationState(prevState => ({ ...prevState, name: e.target.value })) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.attributes.internal_name }
              >
                <input
                  type='text'
                  value={ organizationState.internalName }
                  onChange={ e => setOrganizationState(prevState => ({ ...prevState, internalName: e.target.value })) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.attributes.uid }
              >
                <input
                  type='text'
                  value={ organizationState.uid }
                  onChange={ e => setOrganizationState(prevState => ({ ...prevState, uid: e.target.value })) }
                />
              </InputField>
            </div>
          </div>
        </div>
      </div>

      <div className='card' style={{ paddingTop: 10 }}>
        <div className='card-content'>
          <div className='card-body'>
            <Tabs
              tabs={ tabs }
              currentTab={ currentTab }
              setCurrentTab={ (tab) => setCurrentTab(tab) }
              extraClasses={ 'secondary' }
            />
          </div>
        </div>
      </div>

      { currentTab == 'regions' &&
        <>
          <div className='page-wrapper-header'>
            <div style={{ width: '100%' }}>
              <div className='flex-box items-center content-space-between flex-wrap' style={{ gap: 20 }}>
                <div className='page-header'>
                  <i className={ `fa-light ${ regionIcon }` }/>
                  <h3>
                    { Partners.translations.region.plural }
                    <span className='m-l-10'>({ regions.length })</span>
                  </h3>
                </div>

                { canCreateBranches &&
                  <CreateButton
                    onClickCreate={ () => setShowCreateRegionModal(true) }
                    createTitle={ ReactiveCore.translations.create }
                  />
                }
              </div>
            </div>
          </div>

          <DynamicEntityIndex
            renderKey={ regionRenderKey }
            initialItems={ regions }
            setInitialItems={ setRegions }
            selectAll={ true }
            entity={ 'regions' }
            tabs={ [] }
            tableHeadings={ regionSelectedColumns }
            disableCustomization={ true }
            disableSearch={ true }
            itemRenderer={ regionItemRenderer }
            deletePath={ deleteRegionsPath }
            itemsPath={ regionsPath }
            icon={ regionIcon }
            noResourcesTitle={ Partners.translations.region.no_regions }
            listColumns={ regionListColumns }
            columnTranslations={ Partners.translations.columns }
            isExportable
            exportPath={ exportRegionsPath }
            disableUrlUpdates
          />
        </>
      }

      { currentTab == 'branches' &&
        <>
          <div className='page-wrapper-header'>
            <div style={{ width: '100%' }}>
              <div className='flex-box items-center content-space-between flex-wrap' style={{ gap: 20 }}>
                <div className='page-header'>
                  <i className={ `fa-light ${ branchIcon }` }/>
                  <h3>
                    { Partners.translations.branch.plural }
                    <span className='m-l-10'>({ branchesCountState })</span>
                  </h3>
                </div>

                { canCreateBranches &&
                  <CreateButton
                    onClickCreate={ () => setShowCreateBranchModal(true) }
                    createTitle={ ReactiveCore.translations.create }
                  />
                }
              </div>
            </div>
          </div>

          <DynamicEntityIndex
            key={ renderKey }
            initialItems={ branches }
            setInitialItems={ setBranches }
            selectAll={ true }
            disableDelete={ !canDeleteBranches }
            entity={ 'branches' }
            tabs={ [] }
            tableHeadings={ branchSelectedColumns }
            disableCustomization={ true }
            itemRenderer={ itemRenderer }
            deletePath={ deleteBranchesPath }
            itemsPath={ branchesPath }
            icon={ branchIcon }
            noResourcesTitle={ Partners.translations.branch.no_branches }
            listColumns={ branchListColumns }
            actions={ actions }
            columnTranslations={ Partners.translations.columns }
            fetchOnStart={ true }
            isExportable
            exportPath={ exportBranchesPath }
            disableUrlUpdates
          />
        </>
      }

      { currentTab == 'administrators' &&
        <>
          <div className='page-wrapper-header'>
            <div style={{ width: '100%' }}>
              <div className='flex-box items-center content-space-between flex-wrap' style={{ gap: 20 }}>
                <div className='page-header'>
                  <i className={ `fa-light ${ administratorIcon }` }/>
                  <h3>
                    { Partners.translations.administrator.plural }
                    <span className='m-l-10'>({ administratorsCountState })</span>
                  </h3>
                </div>

                { canInviteOrganizationAdministrator &&
                  <CreateButton
                    onClickCreate={ () => setShowAddNewAdminModal(true) }
                    createTitle={ Partners.translations.invite_administrator }
                  />
                }
              </div>
            </div>
          </div>

          <DynamicEntityIndex
            key={ adminRenderKey }
            initialItems={ administrators }
            setInitialItems={ setAdministrators }
            disableDelete={ true }
            entity={ 'administrators' }
            tabs={ [] }
            tableHeadings={ administratorSelectedColumns }
            disableCustomization={ true }
            itemRenderer={ administratorItemRenderer }
            itemsPath={ getAdministratorsPath }
            icon={ administratorIcon }
            noResourcesTitle={ Partners.translations.administrator.no_administrator }
            listColumns={ administratorListColumns }
            actions={ administratorActions }
            columnTranslations={ Partners.translations.columns }
            fetchOnStart={ true }
            isExportable
            exportPath={ exportAdminsPath }
            selectAll
            disableUrlUpdates
          />
        </>
      }

      { currentTab == 'affiliateCodes' &&
        <>
          <div className='page-wrapper-header'>
            <div style={{ width: '100%' }}>
              <div className='flex-box items-center content-space-between flex-wrap' style={{ gap: 20 }}>
                <div className='page-header'>
                  <i className={ `fa-light ${ affiliateCodeIcon }` }/>
                  <h3>
                    { Partners.translations.affiliateCode.plural }
                  </h3>
                </div>

                { canCreateAffiliateCodes && organization.affiliateCodeAdministrators.length > 0 &&
                  <CreateButton
                    onClickCreate={ () => setShowCreateAffiliateCodeModal(true) }
                    createTitle={ Partners.translations.affiliateCode.create_affiliate_code }
                  />
                }
              </div>
            </div>
          </div>

          <DynamicEntityIndex
            key={ affiliateCodeRenderKey }
            initialItems={ affiliateCodes }
            setInitialItems={ setAffiliateCodes }
            disableDelete
            entity={ 'affiliate_codes' }
            tabs={ [] }
            tableHeadings={ affiliateCodeSelectedColumns }
            disableCustomization={ true }
            itemRenderer={ affiliateCodeItemRenderer }
            itemsPath={ affiliateCodesPath }
            icon={ affiliateCodeIcon }
            noResourcesTitle={ Partners.translations.affiliateCode.no_affiliate_codes }
            listColumns={ affiliateCodeListColumns }
            actions={ affiliateCodeActions }
            columnTranslations={ Partners.translations.columns }
            fetchOnStart={ true }
            disableUrlUpdates
          />
        </>
      }

      { showCreateBranchModal &&
        <Modal
          visible={ showCreateBranchModal }
          closeModal={ closeCreateBranchModal }
          mode='large'
          action={ createBranch }
          actionText={ ReactiveCore.translations.create }
          disableAction={ verifyFields() }
        >
          <div
            className='flex-box flex-column flex-1'
          >
            <div>
              <div className='bold' style={{ fontSize: 25 }}>
                { Partners.translations.branch.create_branch }
              </div>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.branch.attributes.name }
              >
                <input
                  type='text'
                  value={ newBranch.name }
                  onChange={ e => setNewBranch(prevState => ({ ...prevState, name: e.target.value })) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.branch.branch_administrator_email }
              >
                <input
                  type='text'
                  value={ newBranch.branchAdministratorEmail }
                  onChange={ e => setNewBranch(prevState => ({ ...prevState, branchAdministratorEmail: e.target.value })) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.branch.attributes.internal_name }
              >
                <input
                  type='text'
                  value={ newBranch.internalName }
                  onChange={ e => setNewBranch(prevState => ({ ...prevState, internalName: e.target.value })) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.branch.attributes.uid }
              >
                <input
                  type='text'
                  value={ newBranch.uid }
                  onChange={ e => setNewBranch(prevState => ({ ...prevState, uid: e.target.value })) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.branch.attributes.branch_location }
              >
                <textarea
                  value={ newBranch.branchLocation }
                  onChange={ e => setNewBranch(prevState => ({ ...prevState, branchLocation: e.target.value })) }
                />
              </InputField>
            </div>

            { regions.length > 0 &&
              <InputField
                className='col s12'
                label={ Partners.translations.region.model_name }
              >
                <SelectInput
                  options={ [{ title: '-', value: -1 }, ...regions.map(el => ({ title: el.name, value: el.id }))] }
                  currentOption={ newBranch.region }
                  setCurrentOption={ option => setNewBranch(prevState => ({ ...prevState, region: option.value }))}
                />
              </InputField>
            }

          </div>
        </Modal>
      }

      { showCreateAffiliateCodeModal &&
        <Drawer
          visible={ showCreateAffiliateCodeModal }
          closeDrawer={ closeCreateAffiliateCodeModal }
          title={ affiliateCodeToBeEdited ? Partners.translations.affiliateCode.update_affiliate_code : Partners.translations.affiliateCode.create_affiliate_code }
          subtitle={ affiliateCodeToBeEdited ? Partners.translations.affiliateCode.update_affiliate_code_subtitle : Partners.translations.affiliateCode.create_affiliate_code_subtitle }
          action={ createAffiliateCode }
          actionText={ affiliateCodeToBeEdited ? Partners.translations.affiliateCode.update_affiliate_code : ReactiveCore.translations.create }
          disableAction={ !newAffiliateCode.administratorId }
        >
          <div className='flex-box flex-column flex-1'>
            <InputField
              className='col s12'
              label={ Partners.translations.administrator.model_name }
            >
              <SelectInput
                options={ organization.affiliateCodeAdministrators }
                currentOption={ newAffiliateCode.administratorId }
                setCurrentOption={ option => setNewAffiliateCode(prevState => ({ ...prevState, administratorId: option.value })) }
              />
            </InputField>

            <InputField
              className='col s12'
              label={ Partners.translations.affiliateCode.attributes.code }
            >
              <div className='flex-box items-center' style={{ gap: 10 }}>
                <input
                  type='text'
                  value={ newAffiliateCode.code }
                  onChange={ e => setNewAffiliateCode(prevState => ({ ...prevState, code: e.target.value })) }
                />

                <div
                  className='btn'
                  onClick={ generateAffiliateCode }
                >
                  <i className='fa-light fa-arrows-rotate' />
                </div>
              </div>
            </InputField>

            <InputField
              className='col s12'
              label={ Partners.translations.affiliateCode.attributes.expires_at }
            >
              <input
                type='date'
                value={ newAffiliateCode.expiresAt }
                onChange={ e => setNewAffiliateCode(prevState => ({ ...prevState, expiresAt: e.target.value })) }
              />
            </InputField>

            <InputField
              className='col s12'
              label={ Partners.translations.affiliateCode.attributes.active }
            >
              <Toggle
                checked={ newAffiliateCode.active }
                onChange={ e => setNewAffiliateCode(prevState => ({ ...prevState, active: e.target.checked })) }
              />
            </InputField>

          </div>
        </Drawer>
      }

      { showCreateRegionModal &&
        <Modal
          visible
          closeModal={ closeCreateRegionModal }
          mode='medium'
          action={ createRegion }
          actionText={ ReactiveCore.translations.confirm }
          disableAction={ !newRegionName }
        >
          <div className='flex-box flex-column flex-1'>
            <div className='bold' style={{ fontSize: 25 }}>
              { Partners.translations.region.create_region }
            </div>
          </div>

          <div>
            <InputField
              className='col s12'
              label={ Partners.translations.region.attributes.name }
            >
              <input
                type='text'
                value={ newRegionName }
                onChange={ e => setNewRegionName(e.target.value) }
              />
            </InputField>
          </div>

          <div>
            <InputField
              className='col s12'
              label={ Partners.translations.branch.attributes.uid }
            >
              <input
                type='text'
                value={ newRegionUid }
                onChange={ e => setNewRegionUid(e.target.value) }
              />
            </InputField>
          </div>
        </Modal>
      }

      { showAddNewAdminModal &&
        <Modal
          visible={ showAddNewAdminModal }
          closeModal={ closeAddNewAdminModal }
          mode='medium'
          action={ inviteOrganizationAdministrator }
          actionText={ ReactiveCore.translations.confirm }
          disableAction={ !emailValidation(newAdministratorEmail) }
          showConfirmation
          confirmationText={ Partners.translations.invite_organization_administrator_confirmation }
        >
          <div className='flex-box flex-column flex-1'>
            <div className='bold m-b-20' style={{ fontSize: 25 }}>
              { Partners.translations.invite_administrator }
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.user.name }
              >
                <input
                  type='text'
                  value={ newAdministratorName }
                  onChange={ e => setNewAdministratorName(e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.organization.organization_administrator_email }
              >
                <input
                  type='text'
                  value={ newAdministratorEmail }
                  onChange={ e => setNewAdministratorEmail(e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.user.uid }
              >
                <input
                  type='text'
                  value={ newAdministratorUid }
                  onChange={ e => setNewAdministratorUid(e.target.value) }
                />
              </InputField>
            </div>

          </div>
        </Modal>
      }

      { !!administratorToBeDeleted &&
        <ModalAlert
          alert={ Partners.translations.destroy_administrator_alert }
          onSelect={ _e => handleDeleteAdministrator() }
          onClose={ () => setAdministratorToBeDeleted(null) }
        />
      }

      { !!affiliateCodeToBeDeleted &&
        <ModalAlert
          alert={ Partners.translations.affiliateCode.delete_confirmation }
          onSelect={ _e => handleDeleteAffiliateCode() }
          onClose={ () => setAffiliateCodeToBeDeleted(null) }
        />
      }

      <AffiliateLinksDrawer
        affiliateCode={ affiliateCodeLinksModalItem }
        closeDrawer={ () => setAffiliateCodeLinksModalItem(null) }
      />

      { !!administratorToBeEdited &&
        <Modal
          visible={ !!administratorToBeEdited }
          closeModal={ () => setAdministratorToBeEdited(null) }
          mode='medium'
          action={ handleUpdateAdministrator }
          actionText={ ReactiveCore.translations.confirm }
        >
          <div className='flex-box flex-column flex-1'>
            <div className='bold' style={{ fontSize: 32 }}>
              { Partners.translations.administrator.edit_administrator }
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.user.name }
              >
                <input
                  type='text'
                  value={ updatedName }
                  onChange={ e => setUpdatedName(e.target.value) }
                />
              </InputField>
            </div>

            <div>
              <InputField
                className='col s12'
                label={ Partners.translations.user.uid }
              >
                <input
                  type='text'
                  value={ updatedUid }
                  onChange={ e => setUpdatedUid(e.target.value) }
                />
              </InputField>
            </div>

          </div>
          { loading && <GlobalLoader fullPage /> }
        </Modal>
      }

      { loading && <GlobalLoader fullPage/> }

      <FlashMessage ref={ flashMessageRef } />

      <SaveFixedButton
        onSave={ handleOrganizationSave }
        entity={ Partners.translations.organization.plural }
        ref={ ref => setSaveButtonRef(ref) }
      />
      <GlobalImports appProps={ appProps } />
    </>
  )
}
